import React, { useState, useEffect, useContext } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  FormControl,
  FormLabel,
  InputGroup,
  Modal,
  Row,
  Table,
  Tooltip,
  OverlayTrigger,
  Carousel,
} from "react-bootstrap";
import NoIndex from "../../NoIndex";
import Select from "react-select";
import swal from "sweetalert";
import MyContext from "../../../MyContext";

export const Authorblogmodal = ({Authormodal,setAuthormodal,GetAuthorsBlog}) => {
  const {baseUrl}= useContext(MyContext);
  const [newAuthor, setNewAuthor] = useState({
    p_name: "",
    l_name: "",
    p_username: "",
    p_email: "",
    p_bio: "",
    p_profile_image: "",
    p_website_url: "",
    p_social_links: "",
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewAuthor({ ...newAuthor, [name]: value });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!newAuthor.p_name) {
      newErrors.p_name = "First name is required";
      isValid = false;
    }

    if (!newAuthor.l_name) {
      newErrors.l_name = "Last name is required";
      isValid = false;
    }
    if (!newAuthor.p_username) {
      newErrors.p_username = "Username is required";
      isValid = false;
    } else if (
      !/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{3,}$/.test(
        newAuthor.p_username
      )
    ) {
      newErrors.p_username =
        "Username must contain at least one letter, one number, and one special character.";
      isValid = false;
    }
    if (!newAuthor.p_email) {
      newErrors.p_email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(newAuthor.p_email)) {
      newErrors.p_email = "Invalid email format";
      isValid = false;
    }

    if (!newAuthor.p_bio) {
      newErrors.p_bio = "Bio is required";
      isValid = false;
    }

    if (!newAuthor.p_profile_image) {
      newErrors.p_profile_image = "Profile image URL is required";
      isValid = false;
    }

    if (!newAuthor.p_website_url) {
      newErrors.p_website_url = "Website URL is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const slug = (newAuthor.p_name + "-" + newAuthor.l_name)
      .toLowerCase()
      .replace(/\s+/g, "-");
    const mergedName = `${newAuthor.p_name} ${newAuthor.l_name}`.trim();

    try {
      const raw = JSON.stringify({
        p_name: mergedName,
        p_username: newAuthor.p_username,
        p_email: newAuthor.p_email,
        p_bio: newAuthor.p_bio,
        p_profile_image: newAuthor.p_profile_image,
        p_website_url: newAuthor.p_website_url,
        p_social_links: "string",
        slug: slug,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${baseUrl}/api/Blog/CreateAuthors`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        const result = data.result[0];
        if (result && result.result === "Y") {
          swal("Success", result.message, "success");
          GetAuthorsBlog();
          setAuthormodal(false);
        } else {
          swal("Error", "Unexpected result format", "error");
        }
      } else {
        swal("Error", data.msg, "error");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      swal("Error", "Something went wrong. Please try again.", "error");
    }
  };

  return (
    <Modal show={Authormodal} onHide={() => setAuthormodal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Add New Author</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate>
          <div className="row m-0 p-0">
            <Form.Group className="col">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                name="p_name"
                value={newAuthor.p_name}
                onChange={handleInputChange}
                placeholder="Enter First name"
                isInvalid={!!errors.p_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.p_name}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="col">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                name="l_name"
                value={newAuthor.l_name}
                onChange={handleInputChange}
                placeholder="Enter Last name"
                isInvalid={!!errors.l_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.l_name}
              </Form.Control.Feedback>
            </Form.Group>
          </div>
          <div className="row m-0 p-0">
            <Form.Group className="col">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                name="p_username"
                value={newAuthor.p_username}
                onChange={handleInputChange}
                placeholder="Enter author's username"
                isInvalid={!!errors.p_username}
              />
              <Form.Control.Feedback type="invalid">
                {errors.p_username}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="col">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="p_email"
                value={newAuthor.p_email}
                onChange={handleInputChange}
                placeholder="Enter author's email"
                isInvalid={!!errors.p_email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.p_email}
              </Form.Control.Feedback>
            </Form.Group>
          </div>
          <div className="row m-0 p-0">
            <Form.Group className="col">
              <Form.Label>Bio</Form.Label>
              <textarea
                name="p_bio"
                value={newAuthor.p_bio}
                onChange={handleInputChange}
                className="form-control"
                placeholder="Enter author's bio"
                isInvalid={!!errors.p_bio}
              />
              <Form.Control.Feedback type="invalid">
                {errors.p_bio}
              </Form.Control.Feedback>
            </Form.Group>
          </div>
          <div className="row m-0 p-0">
            <Form.Group className="col">
              <Form.Label>Profile Image</Form.Label>
              <Form.Control
                type="text"
                name="p_profile_image"
                value={newAuthor.p_profile_image}
                onChange={handleInputChange}
                placeholder="Enter profile image URL"
                isInvalid={!!errors.p_profile_image}
              />
              <Form.Control.Feedback type="invalid">
                {errors.p_profile_image}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="col">
              <Form.Label>Website URL</Form.Label>
              <Form.Control
                type="url"
                name="p_website_url"
                value={newAuthor.p_website_url}
                onChange={handleInputChange}
                placeholder="Enter website URL"
                isInvalid={!!errors.p_website_url}
              />
              <Form.Control.Feedback type="invalid">
                {errors.p_website_url}
              </Form.Control.Feedback>
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setAuthormodal(false)}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Add Author
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const Uploadimageblog = ({
  showModal,
  handleCloseModal,
  setContent,
  uploadedImageUrl,
  handleImageUpload,
}) => {
  const [imageData, setImageData] = useState({
    title: "",
    alt: "",
    description: "",
  });
  const handleFormSubmit = (e) => {
    e.preventDefault();
    setContent((prevContent) => [
      ...prevContent,
      {
        type: "uploadedImage",
        src: uploadedImageUrl,
        ...imageData,
      },
    ]);
    handleCloseModal();
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setImageData({
      ...imageData,
      [name]: value,
    });
  };

  return (
    <Modal show={showModal} onHide={handleCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>Uploaded Images</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleFormSubmit}>
          <div className="form-group">
            <Form.Label htmlFor="imageTitle">Upload Image </Form.Label>
            <Form.Control
              type="file"
              id="image-upload"
              accept="image/*"
              multiple
              onChange={handleImageUpload}
            />
          </div>

          {uploadedImageUrl && (
            <div className="row m-0 p-0">
              <div className="col-2 ">
                <img
                  src={uploadedImageUrl}
                  alt="Uploaded Preview"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #ddd",
                  }}
                />
              </div>
              <div className="col d-flex align-items-center">
                <h6 className="">URL: {uploadedImageUrl}</h6>
              </div>
            </div>
          )}

          <div className="form-group">
            <Form.Label htmlFor="imageTitle">Image Title</Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={imageData.title}
              onChange={handleInputChange}
              className="form-control"
              placeholder="Enter image title"
            />
          </div>

          <div className="form-group">
            <Form.Label htmlFor="imageAlt">Image Alt Text</Form.Label>
            <Form.Control
              type="text"
              name="alt"
              value={imageData.alt}
              onChange={handleInputChange}
              className="form-control"
              placeholder="Enter image alt text"
            />
          </div>

          <div className="form-group">
            <Form.Label htmlFor="imageDescription">
              Image Description
            </Form.Label>
            <textarea
              name="description"
              value={imageData.description}
              onChange={handleInputChange}
              className="form-control"
              placeholder="Enter image description"
            />
          </div>

          <button type="submit" className="btn btn-primary mt-3">
            Save
          </button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export const Uploadfeatureimageblog = ({
  featureModal,
  handleClosefeatureModal,
  setContent,
  uploadedfeatureImageUrl,
  setSubmitted,
  handlefeatureImageUpload,
  setFeatureimageData,
  featureimageData,
}) => {
  const handlefeatureInputChange = (e) => {
    const { name, value } = e.target;
    setFeatureimageData({
      ...featureimageData,
      [name]: value,
    });
  };
  const handlefeatureFormSubmit = (e) => {
    e.preventDefault();
    setContent((prevContent) => [
      ...prevContent,
      {
        // type: "uploadedImage",
        src: uploadedfeatureImageUrl,
        ...featureimageData,
      },
    ]);
    setSubmitted(true);
    handleClosefeatureModal();
  };
  return (
    <Modal show={featureModal} onHide={handleClosefeatureModal}>
      <Modal.Header closeButton>
        <Modal.Title>Uploaded Feature Images</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handlefeatureFormSubmit}>
          <div className="form-group">
            <Form.Label htmlFor="imageTitle">Upload Image </Form.Label>
            <Form.Control
              type="file"
              id="image-upload"
              accept="image/*"
              multiple
              onChange={handlefeatureImageUpload}
            />
          </div>

          {uploadedfeatureImageUrl && (
            <div className="row m-0 p-0">
              <div className="col-2 ">
                <img
                  src={uploadedfeatureImageUrl}
                  alt="Uploaded Preview"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #ddd",
                  }}
                />
              </div>
              <div className="col d-flex align-items-center">
                <h6 className="">URL: {uploadedfeatureImageUrl}</h6>
              </div>
            </div>
          )}

          <div className="form-group">
            <Form.Label htmlFor="imageTitle">Image Title</Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={featureimageData.title}
              onChange={handlefeatureInputChange}
              className="form-control"
              placeholder="Enter image title"
            />
          </div>

          <div className="form-group">
            <Form.Label htmlFor="imageAlt">Image Alt Text</Form.Label>
            <Form.Control
              type="text"
              name="alt"
              value={featureimageData.alt}
              onChange={handlefeatureInputChange}
              className="form-control"
              placeholder="Enter image alt text"
            />
          </div>

          <div className="form-group">
            <Form.Label htmlFor="imageDescription">
              Image Description
            </Form.Label>
            <textarea
              name="description"
              value={featureimageData.description}
              onChange={handlefeatureInputChange}
              className="form-control"
              placeholder="Enter image description"
            />
          </div>

          <button type="submit" className="btn btn-primary mt-3">
            Save
          </button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
